const Contact = {
    $contactFormContainer: document.querySelector('#contact-form'),
    $contactFormBuralisteContainer: document.querySelector('#contact-form-buraliste'),
    $selectFonction: document.querySelector('[name=your-function]'),
    inputsName: ['your-firstname', 'your-lastname', 'your-email', 'your-function', 'your-subject', 'your-message'],
    inputsValues: {},
    init() {
        if (this.$contactFormContainer) {
            this.initRedirection();
        }

        if (this.$contactFormBuralisteContainer) {
            this.initFormValues();
        }
    },

    initRedirection() {
        // console.log(this.$selectFonction);
        if (this.$selectFonction) {
            this.$selectFonction.addEventListener('change', () => {
                // console.log('value:', this.$selectFonction.value);
                if (this.$selectFonction.value == "Buraliste") {
                    this.inputsName.forEach( ($input) => {
                        // console.log('input:', $input);
                        this.inputsValues[$input] = this.$contactFormContainer.querySelector('[name='+$input+']').value;
                    });

                    console.log(this.inputsValues);
                    sessionStorage.setItem('inputValues', JSON.stringify(this.inputsValues));
                    window.location.href = '/contact-buraliste/';
                }
            });
        }
    },

    initFormValues () {
        const inputsValues = JSON.parse(sessionStorage.getItem('inputValues'));
        this.inputsName.forEach(($input) => {
            if (inputsValues[$input] && this.$contactFormBuralisteContainer.querySelector('[name='+$input+']')) {
                this.$contactFormBuralisteContainer.querySelector('[name='+$input+']').classList.add('has-content');
                this.$contactFormBuralisteContainer.querySelector('[name='+$input+']').value = inputsValues[$input];
            }
        });
    }
}

export default Contact;
